import { render, staticRenderFns } from "./PermissionsGroupsView.vue?vue&type=template&id=6cdb7e48&"
import script from "./PermissionsGroupsView.vue?vue&type=script&lang=js&"
export * from "./PermissionsGroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports